import { http } from 'globalState/global-state.js';

export const addToBookmark = (params) => {
    return http.xmlUnsafeRequest.post(
        '/?r=bookmark/add',
        params
    );
};

export const removeFromBookmark = (params) => {
    return http.xmlUnsafeRequest.post(
        '/personal/bookmarks/remove/',
        params
    );
};